(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.setHeaderHeight();

      this.mediaQuery = window.matchMedia('(max-width: 990px)');
      this.setHeaderHeightHandler = this.setHeaderHeight.bind(this);
      this.mediaQuery.addEventListener('change', this.setHeaderHeightHandler);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => {
        this.preventReveal = true;
      };

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
    }

    setHeaderHeight() {
      if (!this.header) return;

      document.documentElement.style.setProperty(
        '--header-height',
        `${this.header.offsetHeight}px`
      );
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);

      if (this.mediaQuery && this.setHeaderHeightHandler) {
        this.mediaQuery.removeEventListener('change', this.setHeaderHeightHandler);
      }
    }

    createObserver() {
      const observer = new IntersectionObserver((entries) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    isInteractivePanelOpen() {
      const mobileMenuOpen = this.querySelector('header-drawer details[open]');
      const desktopMenuOpen = this.querySelector('header-menu details[open]');
      const searchModalOpen = this.querySelector('details-modal details[open]');

      return Boolean(
        mobileMenuOpen ||
        desktopMenuOpen ||
        searchModalOpen ||
        (this.predictiveSearch && this.predictiveSearch.isOpen)
      );
    }

    onScroll() {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      const previousScrollTop = this.currentScrollTop;
      const headerBottom = Number.isFinite(this.headerBounds.bottom)
        ? this.headerBounds.bottom
        : 0;

      this.currentScrollTop = scrollTop;

      if (this.isInteractivePanelOpen()) {
        this.reveal();
        return;
      }

      if (scrollTop <= headerBottom) {
        this.header.classList.remove('scrolled-past-header');
        this.preventReveal = false;
        requestAnimationFrame(this.reset.bind(this));
        return;
      }

      if (scrollTop > previousScrollTop + 2) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventHide) {
          requestAnimationFrame(this.hide.bind(this));
        }

        return;
      }

      if (scrollTop < previousScrollTop - 2) {
        this.header.classList.add('scrolled-past-header');
        this.preventReveal = false;
        requestAnimationFrame(this.reveal.bind(this));
      }
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky'
      );
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add(
        'shopify-section-header-sticky',
        'animate'
      );
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );
    }

    closeMenuDisclosure() {
      this.disclosures =
        this.disclosures || this.header.querySelectorAll('header-menu');

      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal =
        this.searchModal || this.header.querySelector('details-modal');

      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["va-campaign"] && !Shopify.designMode) return;
  try {
    
if(!window.vaCampaignCopyInstalled){
  window.vaCampaignCopyInstalled=true;
  document.addEventListener('click',async event=>{
    const button=event.target.closest('[data-va-copy-code]');
    if(!button)return;
    const code=button.dataset.vaCopyCode;
    let copied=false;
    try{
      if(navigator.clipboard&&window.isSecureContext){await navigator.clipboard.writeText(code);copied=true;}
    }catch(error){}
    if(!copied){
      const field=document.createElement('textarea');
      field.value=code;field.setAttribute('readonly','');field.style.position='fixed';field.style.opacity='0';
      document.body.appendChild(field);field.select();
      try{copied=document.execCommand('copy');}catch(error){}
      field.remove();
    }
    const status=button.closest('.va-campaign').querySelector('.va-campaign__feedback');
    status.textContent=copied?'Code copié : '+code:'Impossible de copier le code automatiquement.';
    if(copied){
      button.querySelector('span').textContent='Copié !';
      clearTimeout(button.vaCopyTimer);
      button.vaCopyTimer=setTimeout(()=>{button.querySelector('span').textContent=code;status.textContent='';},2200);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["va-contact-editorial"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('submit', function (event) {
  var form = event.target.closest('.vac-tracking__form');
  if (!form) return;
  event.preventDefault();
  var number = form.querySelector('[name="tracking_number"]').value.trim().replace(/[\s-]/g, '');
  var carrier = form.querySelector('[name="carrier"]').value;
  var status = form.parentElement.querySelector('.vac-tracking__status');
  var showStatus = function (message) {
    status.textContent = message;
    status.hidden = false;
  };
  if (!/^[A-Za-z0-9]{8,30}$/.test(number) || !carrier) {
    showStatus(form.dataset.invalid);
    return;
  }
  if (carrier === 'mondial-relay') {
    if (!/^[0-9]{8}$/.test(number)) {
      showStatus(form.dataset.mondialInvalid);
      return;
    }
    if (!navigator.clipboard || !navigator.clipboard.writeText) {
      showStatus(form.dataset.copyFailed);
      return;
    }
    navigator.clipboard.writeText(number).then(function () {
      window.location.assign('https://www.mondialrelay.fr/suivi-de-colis/');
    }).catch(function () {
      showStatus(form.dataset.copyFailed);
    });
    return;
  }
  if (carrier === 'colissimo') {
    window.location.assign('https://www.laposte.fr/outils/suivre-vos-envois?code=' + encodeURIComponent(number));
  } else if (carrier === 'chronopost') {
    window.location.assign('https://www.chronopost.fr/tracking-no-cms/suivi-page?langue=fr&listeNumerosLT=' + encodeURIComponent(number));
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["va-home"] && !Shopify.designMode) return;
  try {
    
(()=>{
  if(window.vaHomeInstalled)return;
  window.vaHomeInstalled=true;
  const reduce=window.matchMedia('(prefers-reduced-motion: reduce)');
  let userReduced=false;
  try{userReduced=sessionStorage.getItem('va-reduced-motion')==='true';}catch(e){}
  const motionButton=document.querySelector('.va-motion-control');
  const updateMotion=()=>{const paused=reduce.matches||userReduced;document.documentElement.classList.toggle('va-no-motion',paused);if(motionButton){motionButton.setAttribute('aria-pressed',String(paused));motionButton.setAttribute('aria-label',paused?motionButton.dataset.enable:motionButton.dataset.reduce);motionButton.querySelector('span').textContent=paused?'▷':'Ⅱ';}};
  updateMotion();reduce.addEventListener('change',updateMotion);
  if(motionButton)motionButton.addEventListener('click',()=>{userReduced=!userReduced;try{sessionStorage.setItem('va-reduced-motion',String(userReduced));}catch(e){}updateMotion();});
  let reveal;
  if('IntersectionObserver' in window)reveal=new IntersectionObserver(es=>{es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('va-seen');reveal.unobserve(e.target);}});},{threshold:.12});
  const init=(scope=document)=>{
    scope.querySelectorAll('.va-reveal,#MainContent .card-wrapper,#MainContent .article-card-wrapper').forEach((e,i)=>{if(e.dataset.vaObserved)return;e.dataset.vaObserved='true';e.classList.add('va-reveal');e.style.setProperty('--va-delay',`${Math.min(i%3,2)*75}ms`);if(reveal)reveal.observe(e);});
    scope.querySelectorAll('.va-gallery').forEach(gallery=>{if(gallery.dataset.vaBound)return;gallery.dataset.vaBound='true';
      const main=gallery.parentElement.querySelector('.va-main-photo');
      gallery.addEventListener('click',event=>{const choice=event.target.closest('[data-va-photo]');if(!choice||!main||choice.getAttribute('aria-pressed')==='true')return;
        gallery.querySelectorAll('[data-va-photo]').forEach(button=>button.setAttribute('aria-pressed',String(button===choice)));
        main.removeAttribute('srcset');main.removeAttribute('sizes');main.src=choice.dataset.src;main.alt=choice.dataset.alt;main.classList.toggle('va-photo-product',choice.dataset.appearance==='product');
        main.closest('.va-offer-art').classList.toggle('va-has-gallery-product',choice.dataset.appearance==='product');
        if(!reduce.matches&&!userReduced&&typeof main.animate==='function')main.animate([{opacity:.55,transform:'scale(.975)'},{opacity:1,transform:'scale(1)'}],{duration:360,easing:'ease-out'});
      });
    });
    scope.querySelectorAll('.va-buy-form').forEach(form=>{if(form.dataset.vaBound)return;form.dataset.vaBound='true';
      form.querySelectorAll('[name="va-format-choice"]').forEach(choice=>choice.addEventListener('change',()=>{if(!choice.checked)return;const section=form.closest('.va-offer');form.querySelector('[name="id"]').value=choice.value;section.querySelector('[data-va-price]').textContent=choice.dataset.price;section.querySelector('[data-va-unit]').textContent=choice.dataset.unit;section.querySelector('[data-va-details]').href=choice.dataset.url;const status=section.querySelector('.va-form-status');if(status)status.textContent='';}));
      form.addEventListener('submit',async event=>{
      const chosen=form.querySelector('[name="va-format-choice"]:checked');const idInput=form.querySelector('[name="id"]');if(idInput)idInput.value=chosen?chosen.value:idInput.dataset.initialId;
      const drawer=document.querySelector('cart-drawer');
      if(!drawer||typeof drawer.renderContents!=='function')return;
      event.preventDefault();
      if(form.dataset.busy==='true')return;
      const button=form.querySelector('[type=submit]'),status=form.querySelector('.va-form-status');
      const statusBox=form.parentElement.querySelector('.va-form-status')||status;
      const feedback=statusBox;
      form.dataset.busy='true';button.disabled=true;button.setAttribute('aria-busy','true');
      if(feedback)feedback.textContent=feedback.dataset.loading;
      let added=false;
      try{
        const data=new FormData(form);data.set('sections',drawer.getSectionsToRender().map(s=>s.id).join(','));data.set('sections_url',location.pathname);drawer.setActiveElement(button);
        const result=await fetch(form.action+'.js',{method:'POST',body:data,headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'}});
        const response=await result.json();if(!result.ok||response.status)throw new Error(response.description||feedback?.dataset.error);
        added=true;if(feedback)feedback.textContent=feedback.dataset.success;
        const cartLink=form.querySelector('.va-cart-link');if(cartLink)cartLink.hidden=false;
        drawer.classList.remove('is-empty');drawer.renderContents(response);
        if(typeof publish==='function'&&typeof PUB_SUB_EVENTS!=='undefined')publish(PUB_SUB_EVENTS.cartUpdate,{source:'va-home',productVariantId:data.get('id'),cartData:response});
      }catch(error){if(added){window.location.assign(window.Shopify.routes.root+'cart');}else if(feedback){feedback.textContent=error.message&&error.message!=='Failed to fetch'?error.message:feedback.dataset.error;}}
      finally{button.disabled=false;button.removeAttribute('aria-busy');form.dataset.busy='false';}
    });});
    const collection=document.querySelector('[id$="__va_products"]');if(collection)collection.classList.add('va-home-anchor');
  };
  init();document.addEventListener('shopify:section:load',e=>init(e.target));
  const scenes=new Set();
  if('IntersectionObserver' in window){const observer=new IntersectionObserver(es=>{es.forEach(e=>{if(e.isIntersecting)scenes.add(e.target);else scenes.delete(e.target);});});document.querySelectorAll('.va-offer-art,.va-story-image').forEach(e=>observer.observe(e));}
  let frame=0;
  window.addEventListener('scroll',()=>{if(frame||reduce.matches||userReduced||innerWidth<900||!scenes.size)return;frame=requestAnimationFrame(()=>{scenes.forEach(scene=>{const el=scene.querySelector('.va-parallax');if(el){const r=scene.getBoundingClientRect();const shift=Math.max(-22,Math.min(22,(innerHeight/2-r.top-r.height/2)*.055));el.style.transform=`translateY(${shift}px)`;}});frame=0;});},{passive:true});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["va-story-editorial"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.vasReady) return;
    root.dataset.vasReady = 'true';
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches || document.body.classList.contains('va-no-motion');
    if (reduced) return;
    root.classList.add('has-motion');
    var reveals = root.querySelectorAll('.vas-reveal, .vas-mobile-reveal');
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { entry.target.classList.add('vas-seen'); observer.unobserve(entry.target); }
        });
      }, { threshold: 0.12 });
      reveals.forEach(function (element) { observer.observe(element); });
    } else {
      reveals.forEach(function (element) { element.classList.add('vas-seen'); });
    }
    var hero = root.querySelector('.vas-hero');
    var map = root.querySelector('.vas-map__svg');
    var mapPoint = root.querySelector('.vas-map__point');
    var mapPin = root.querySelector('.vas-map__pin');
    var journey = root.querySelector('.vas-journey');
    var counter = root.querySelector('[data-vas-counter]');
    var raf = false;
    function positionPin() {
      var frame = map.parentElement.getBoundingClientRect();
      var point = mapPoint.getBoundingClientRect();
      mapPin.style.right = 'auto';
      mapPin.style.left = Math.max(14, Math.min(point.left - frame.left + 8, frame.width - mapPin.offsetWidth - 14)).toFixed(1) + 'px';
      mapPin.style.top = Math.max(20, point.top - frame.top - 2).toFixed(1) + 'px';
    }
    function update() {
      raf = false;
      if (!root.isConnected) return;
      var viewport = window.innerHeight;
      var heroRect = hero.getBoundingClientRect();
      var heroShift = Math.max(0, Math.min(1, -heroRect.top / Math.max(heroRect.height, 1))) * 35;
      root.style.setProperty('--vas-hero-shift', heroShift.toFixed(1) + 'px');
      if (window.matchMedia('(max-width: 749px)').matches) {
        var mobileRect = map.parentElement.getBoundingClientRect();
        var mobileProgress = Math.max(0, Math.min(1, (viewport * .82 - mobileRect.top) / (mobileRect.height + viewport * .45)));
        var mobileEase = mobileProgress * mobileProgress * (3 - 2 * mobileProgress);
        map.setAttribute('viewBox', [55 * mobileEase, 8 * mobileEase, 460 - 55 * mobileEase, 650 - 78 * mobileEase].map(function (n) { return n.toFixed(1); }).join(' '));
        positionPin();
        return;
      }
      var rect = journey.getBoundingClientRect();
      var travel = Math.max(rect.height - viewport, 1);
      var progress = Math.max(0, Math.min(1, -rect.top / travel));
      var stage = progress < .33 ? 0 : progress < .66 ? 1 : 2;
      journey.dataset.stage = String(stage);
      counter.textContent = '0' + (stage + 1) + ' / 03';
      journey.style.setProperty('--vas-progress', (progress * 100).toFixed(1) + '%');
      var ease = progress * progress * (3 - 2 * progress);
      var x = 0 + 215 * ease;
      var y = 0 + 20 * ease;
      var w = 460 - 215 * ease;
      var h = 650 - 300 * ease;
      map.setAttribute('viewBox', [x, y, w, h].map(function (n) { return n.toFixed(1); }).join(' '));
      positionPin();
    }
    function schedule() { if (!raf) { raf = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    update();
  }
  document.querySelectorAll('.vas').forEach(init);
  document.addEventListener('shopify:section:load', function (event) { event.target.querySelectorAll('.vas').forEach(init); });
})();

  } catch(e) { console.error(e); }
})();
})();
